import { render, staticRenderFns } from "./jumpConfig.vue?vue&type=template&id=a796d6c4&scoped=true"
import script from "./jumpConfig.vue?vue&type=script&lang=js"
export * from "./jumpConfig.vue?vue&type=script&lang=js"
import style0 from "./jumpConfig.vue?vue&type=style&index=0&id=a796d6c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a796d6c4",
  null
  
)

export default component.exports